import { useQuery } from '@src/shared/query';
import { keepPreviousData } from '@tanstack/react-query';
import type { AbsenceWarningDto, AbsenceWarnings } from '../../types';
import { absenceWarningsUrl } from './constants';

function selectWarnings(data: AbsenceWarningDto[]): AbsenceWarnings {
  const warnings: AbsenceWarnings = new Map();
  for (const { user_id, ...summary } of data) {
    warnings.set(user_id, summary);
  }
  return warnings;
}

// Only rows with a warning come back, and only the rows the reader looks
// after: a missing user has nothing to show.
export default function useAbsenceWarnings() {
  const query = useQuery<AbsenceWarningDto[], AbsenceWarnings>(
    absenceWarningsUrl,
    {
      select: selectWarnings,
      placeholderData: keepPreviousData,
    },
  );

  const { data: warnings = new Map(), ...restQuery } = query;
  return {
    warnings,
    ...restQuery,
  };
}
